import { Switch, Route ,Redirect  } from "react-router-dom";
import { ROOT,DASHBOARD,ADDSTUDENT ,STUDENTS_LIST,FEE_SETUP, STUDENTS_DETAILS} from "./constants";
import StudentDashboard from "../components/Dashboard/student";
import '../assets/css/style.css';
import '../assets/css/responsive.css';
import Notification from "../components/Notification";
import PaymentsList from "../components/PaymentsLIst";
import StudentPaymentHistory from "../components/Student/Edit/studentPaymentHistory";
import ResetPassword from "../pages/ForgotPassword/ResetPassword";
export const StudentRouterConfig = () => {
  return (
    <div>
      <Switch>
        {/* List all public routes here */}
        <Route exact path={ROOT} >
             <Redirect to={DASHBOARD} />
        </Route>
        <Route exact path={DASHBOARD} component={StudentDashboard} />
        <Route exact path="/student/notifications" component={Notification} />
        <Route exact path="/student/paymentsList" component={StudentPaymentHistory} />
        <Route exact path="/student/resetPassword" component={ResetPassword} />
        <Route exact path="*">
          <Redirect to={DASHBOARD} />
        </Route>
      </Switch>
    </div>
  );
};


